export function isChinese(text: string) {
  if (!text) return false;
  // 匹配中文字符的正则表达式
  const chineseRegex = /[\u4e00-\u9fa5]/g;

  // 匹配英文单词的正则表达式
  const englishWordRegex = /\b[A-Za-z]+\b/g;

  // 统计中文字符数
  const chineseCount = (text.match(chineseRegex) || []).length;

  // 将文本按空格分割为单词数组，然后统计英文单词数
  const wordsArray = text.split(/\s+/);
  const englishWordCount = wordsArray.filter((word) =>
    word.match(englishWordRegex),
  ).length;

  return chineseCount > englishWordCount;
}

export function convertAbstractToMarkdownAdvanced(
  abstractText: string,
): string {
  // 按行分割文本
  const lines = abstractText.split('\n').filter((line) => line.trim() !== '');

  let markdown = '';

  lines.forEach((line) => {
    // 检测以大写字母或中文字符开头，后跟冒号的模式
    const isHeader = /^([A-Z\s]+|[\u4e00-\u9fa5]+)[:：]/.test(line.trim());

    if (isHeader) {
      // 提取标题和内容
      const regex = /^([^:：]+)[:：](.*)$/;
      const match = line.match(regex);

      if (match) {
        const header = match[1].trim();
        const content = match[2].trim();

        // 添加标题为H4级别
        markdown += `\n#### ${header}\n\n`;
        // 添加内容（如果有）
        if (content) {
          markdown += `${content}\n\n`;
        }
      } else {
        // 如果正则匹配失败，将整行作为普通内容处理
        markdown += `${line.trim()}\n\n`;
      }
    } else {
      // 添加内容到当前段落
      if (line.trim() !== '') {
        markdown += `${line.trim()}\n\n`;
      }
    }
  });

  return markdown.trim();
}

export const maskApiKey = (key: string) => {
  if (key.length <= 8) return key; // 如果密钥太短则不脱敏
  const prefix = key.substring(0, 7);
  const maskedLength = key.length - 7;
  const maskedPart = '*'.repeat(maskedLength);
  return `${prefix}${maskedPart}`;
};

export const isEmptyObject = (obj: Object) => {
  return Object.getOwnPropertyNames(obj).length === 0;
};
